import React from 'react'
import { CalenderIcon } from "../../../components/Icon";
import DatePicker from "react-datepicker";
import moment from "moment";
import { handleDate } from '../../../utils/commonFunctions';
import { CircularAvatar } from '../../commons';
import { LoginResponseType } from '../../../redux/auth/authTypes';

type AppProps={
    data:any,
    handleInputChange:(data:any)=>void;
    loginData: LoginResponseType;
    setData:any;
}

const ClientMeetUpEditForm = ({data,handleInputChange,loginData,setData}:AppProps) => {
  return (
    <div className="meet_up_form">
    <div className="fillForm ml-1">Fill the form below.</div>

    <div>
      <form>
        <div className="form-group">
          <div>
            <label
              htmlFor="actionName"
              className={data?.scopeOfWork ? "active" : ""}
            >
              Scope Of Work
            </label>
            <textarea
              className={`form-control meet-textarea`}
              name="scopeOfWork"
              value={data?.scopeOfWork}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        </div>
      </form>
    </div>
    <div>
      <form>
        <div className="form-group">
          <div>
            <label
              htmlFor="actionName"
              className={data?.turnOverYearly ? "active" : ""}
            >
              Yearly Turnover
            </label>
            <input
              type="text"
              className={`form-control meet-input`}
              name="turnOverYearly"
              value={data?.turnOverYearly}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        </div>
      </form>
    </div>

    <div className="form_header">Entries Details</div>

    <div className="d-flex" style={{gap:"1px"}}>
    <div className="flex-1">
      <form>
        <div className="form-group">
          <div>
            <label
              htmlFor="actionName"
              className={data?.numberOfSalesEntries ? "active" : ""}
            >
              Monthly Sales Entries
            </label>
            <input
              type="number"
              className={`form-control`}
              name="numberOfSalesEntries"
              value={data?.numberOfSalesEntries}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        </div>
      </form>
    </div>
    <div className="flex-1">
      <form>
        <div className="form-group">
          <div>
            <label
              htmlFor="actionName"
              className={data?.numberOfPurchaseEntries ? "active" : ""}
            >
              Monthly Purchase Entries
            </label>
            <input
              type="number"
              className={`form-control`}
              name="numberOfPurchaseEntries"
              value={data?.numberOfPurchaseEntries}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        </div>
      </form>
    </div>
    </div>

   
    <div style={{width:"48%"}}>
      <form>
        <div className="form-group">
          <div>
            <label
              htmlFor="actionName"
              className={data?.numberOfBankEntries ? "active" : ""}
            >
              Monthly Bank Entries
            </label>
            <input
              type="number"
              className={`form-control`}
              name="numberOfBankEntries"
              value={data?.numberOfBankEntries}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        </div>
      </form>
    </div>


    <div className="form_header">
      Other Details
    </div>
    <div>
      <form>
        <div className="form-group">
          <div>
            <label
              htmlFor="actionName"
              className={data?.bussinessType ? "active" : ""}
            >
              Business Type
            </label>
            <input
              type="text"
              className={`form-control`}
              name="bussinessType"
              value={data?.bussinessType}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        </div>
      </form>
    </div>
    <div>
      <form>
        <div className="form-group">
          <div>
            <label
              htmlFor="actionName"
              className={data?.workingHoursInClientPlace ? "active" : ""}
            >
             Monthly Working Hours in client place
            </label>
            <input
              type="number"
              className={`form-control`}
              name="workingHoursInClientPlace"
              value={data?.workingHoursInClientPlace}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        </div>
      </form>
    </div>
    <div>
      <form>
        <div className="form-group">
          <div>
            <label
              htmlFor="actionName"
              className={data?.currentDataInWhichSoftware ? "active" : ""}
            >
              Current Software Used By Client
            </label>
            <input
              type="text"
              className={`form-control`}
              name="currentDataInWhichSoftware"
              value={data?.currentDataInWhichSoftware}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        </div>
      </form>
    </div>

    <div>
      <form>
        <div className="form-group">
          <div>
            <label
              htmlFor="actionName"
              className={data?.startingMonthOfAccounting ? "active" : ""}
            >
              Starting Month Of Accounting Service
            </label>

            <div className="d-flex flex-row position-relative">
              <div className="date-picker-wraper mr-0 w-100">
                <DatePicker
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  selected={
                    data?.startingMonthOfAccounting
                      ?  moment(data.startingMonthOfAccounting, "MM-YYYY").toDate()
                      : null
                  }
                  onChange={(e: any) =>
                      !!e
                      ? setData({
                          ...data,
                          startingMonthOfAccounting: handleDate(
                            moment(e).format("MM-YYYY")
                          ),
                        })
                      : {}
                  }
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  // disabled={!isEdit}
                  name="date_of_birth"
                  placeholderText="Select"
                  className="form-control"
                />
                <span
                  className="calender-icon"
                  style={{
                    right: "20px",
                    top: "10px",
                    cursor: "pointer",
                  }}
                >
                  <CalenderIcon />
                </span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div>
      <form>
        <div className="form-group">
          <div>
            <label
              htmlFor="actionName"
              className={data?.remark ? "active" : ""}
            >
              Remark
            </label>

            <textarea
              className={`form-control meet-textarea`}
              name="remark"
              value={data?.remark}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        </div>
      </form>
    </div>
   
    <div>
      <form>
        <div className="form-group">
          <div>
            <label
              htmlFor="actionName"
              className={data?.anyOldWork ? "active" : ""}
            >
              Any Old Work
            </label>

            <textarea
              className={`form-control meet-textarea`}
              name="anyOldWork"
              value={data?.anyOldWork}
              onChange={(e) => handleInputChange(e)}
            />
          </div>
        </div>
      </form>
    </div>

     {data?.nameOfLeadAssignedByBdTeam?.first_name ? <div className="mt-4">
     <div className="assignee-header mb-1">
    Name of Lead Assigned by BD Team
    </div>
    <div>
    <div
    className="d-flex justify-content-sm-start"
    style={{ gap: "10px" }}
  >
    <CircularAvatar
      name={data?.nameOfLeadAssignedByBdTeam?.first_name + data?.nameOfLeadAssignedByBdTeam?.last_name}
      image={data?.nameOfLeadAssignedByBdTeam?.profile_pic?.file_url}
    />
   {data?.nameOfLeadAssignedByBdTeam?.first_name+ " " + data?.nameOfLeadAssignedByBdTeam?.last_name}
  </div>
    </div>
     </div> : null}
    


   

   <div className="mt-4">
   <div className="assignee-header mb-1">
    Checklist Status
    </div>

    <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "15px",
        }}
      >
        <label className="switchs">
          <input
            type="checkbox"
            checked={data?.meetUpComplete}
            onChange={() => setData({...data,meetUpComplete:!data?.meetUpComplete})}
          />
          <span className="sliders rounds"></span>
        </label>
        <span style={{ fontWeight: "500" }}>Mark as Completed</span>
      </div>
   </div>

    <div className="note mt-5">
    Note : Once you mark this as completed and submit, client will receive an email about updates.
    </div>
  


  </div>
  )
}

export default ClientMeetUpEditForm
